import React, { useState, useEffect } from 'react';
import { ArrowRight, Plug, Zap, ChevronLeft, ChevronRight } from 'lucide-react';
import { FEATURED_INTEGRATIONS } from '../mock';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const Card = ({ i, active, onClick }) => (
  <button
    onClick={onClick}
    className={`shrink-0 w-[300px] md:w-[340px] text-left rounded-2xl p-6 border transition-all duration-500 ${
      active
        ? 'bg-[#0a0e27] text-white border-[#0a0e27] scale-[1.02] shadow-2xl'
        : 'bg-white border-slate-200 hover:border-[#FF5B24]/40 hover:shadow-lg'
    }`}
  >
    <div className="flex items-center gap-3">
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center font-black text-white text-lg shadow-md"
        style={{ backgroundColor: i.color }}
      >
        {i.letter}
      </div>
      <div>
        <div className={`text-[10px] font-bold uppercase tracking-widest ${active ? 'text-[#FF5B24]' : 'text-slate-400'}`}>
          {i.category}
        </div>
        <div className={`font-extrabold text-lg ${active ? 'text-white' : 'text-[#0a0e27]'}`}>{i.name}</div>
      </div>
    </div>
    <p className={`mt-4 text-sm leading-relaxed ${active ? 'text-white/80' : 'text-slate-600'}`}>
      {i.desc}
    </p>
    <div className={`mt-5 inline-flex items-center gap-1.5 text-xs font-semibold ${active ? 'text-[#FF5B24]' : 'text-[#0a0e27]'}`}>
      Ver documentação <ArrowRight size={12} />
    </div>
  </button>
);

const IntegrationsCarousel = () => {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  const list = FEATURED_INTEGRATIONS;

  useEffect(() => {
    const id = setInterval(() => setActive((p) => (p + 1) % list.length), 4200);
    return () => clearInterval(id);
  }, [list.length]);

  const prev = () => setActive((p) => (p - 1 + list.length) % list.length);
  const next = () => setActive((p) => (p + 1) % list.length);

  return (
    <section id="integrations" className="relative py-24 bg-gradient-to-b from-[#FAF6F2] to-white overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#FF5B24]">
              <Plug size={13} /> Integrações nativas
            </div>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a0e27] leading-tight">
              Conecte a CoreDesk ao <span className="text-[#FF5B24]">seu stack</span>
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              Integrações prontas com as ferramentas que você já usa. Suba sua operação em dias, não em meses.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={prev} className="w-11 h-11 rounded-full border border-slate-200 bg-white flex items-center justify-center hover:border-[#FF5B24] hover:text-[#FF5B24] transition-colors">
              <ChevronLeft size={18} />
            </button>
            <button onClick={next} className="w-11 h-11 rounded-full border border-slate-200 bg-white flex items-center justify-center hover:border-[#FF5B24] hover:text-[#FF5B24] transition-colors">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        {/* Carousel */}
        <div className="mt-12 relative">
          <div className="overflow-hidden">
            <div
              className="flex gap-5 transition-transform duration-700 ease-out"
              style={{ transform: `translateX(calc(50% - 170px - ${active * 356}px))` }}
            >
              {list.map((i, idx) => (
                <Card key={i.name} i={i} active={idx === active} onClick={() => setActive(idx)} />
              ))}
            </div>
          </div>

          {/* Dots */}
          <div className="mt-8 flex justify-center gap-2">
            {list.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setActive(idx)}
                className={`h-1.5 rounded-full transition-all ${idx === active ? 'w-8 bg-[#FF5B24]' : 'w-1.5 bg-slate-300'}`}
                aria-label={`Ir para ${idx + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-3">
          <Button onClick={() => navigate('/integracoes')} className="btn-coral rounded-full h-11 px-6 text-sm font-semibold gap-1.5">
            Ver todas as integrações <ArrowRight size={15} />
          </Button>
          <Button variant="outline" onClick={() => navigate('/contato')} className="rounded-full h-11 px-6 text-sm font-semibold border-[#0a0e27]/15 hover:bg-[#0a0e27] hover:text-white">
            <Zap size={15} className="mr-1.5" /> Precisa de uma integração custom?
          </Button>
        </div>
      </div>
    </section>
  );
};

export default IntegrationsCarousel;
